import { useMutation } from '@tanstack/react-query';
import ChatService from '../services/chat.service';

/**
 * Custom hook to update a folder using React Query's mutation.
 *
 * @param token - The authentication token required for the API call.
 * @returns An object containing the mutation state and the `mutate` function to trigger the update.
 */
export const useUpdateFolder = () => {
    const chatService = new ChatService();

    return useMutation({
        mutationFn: ({
            folderId,
            organizationId,
            name,
            parentId,
        }: {
            folderId: string;
            organizationId: string;
            name: string;
            parentId?: string;
        }) => chatService.updateFolder(folderId, organizationId, name, parentId),
    });
};
